import { lazy } from 'react';

export const LandingPage = lazy(() => import('./Routes/LandingScreen'));

export const DashboardHome = lazy(() => import('./Routes/DashboardHome'));

export const Applications = lazy(() => import('./Routes/Applications'));

export const ApplicationDetail = lazy(() => import('./Routes/Applications/ApplicationDetail'));

export const Contracts = lazy(() => import('./Routes/Contracts'));
export const LeaseContractDetail = lazy(() => import('./Routes/Contracts/Detail/Lease'));
export const PmaContractDetail = lazy(() => import('./Routes/Contracts/Detail/PMA'));
export const OffPlanContractDetail = lazy(() => import('./Routes/Contracts/Detail/OffPlan'));
export const MusatahaContractDetail = lazy(() => import('./Routes/Contracts/Detail/Musataha'));
export const MortgageContractDetail = lazy(() => import('./Routes/Contracts/Detail/Mortgage'));
export const POAContractDetail = lazy(() => import('./Routes/Contracts/Detail/POA'));

// Lease Application
export const TenantReview = lazy(() => import('./Routes/Applications/Lease/TenantReview'));
export const TenantReject = lazy(() => import('./Routes/Applications/Lease/TenantReview/submitRejection'));
export const TenantRejectClosure = lazy(() => import('./Routes/Applications/Lease/TenantReview/submitClosureReturned'));
export const TenantRejectCancel = lazy(() => import('./Routes/Applications/Lease/TenantReview/submitCancelleReturned'));
export const TenantApproval = lazy(() => import('./Routes/Applications/Lease/TenantReview/submitApproval'));
export const OwnerTermination = lazy(() => import('./Routes/Applications/Lease/OwnerReview/submitTermination'));
export const OwnerApprovalClosureReject = lazy(() => import('./Routes/Applications/Lease/OwnerReview/submitRejection'));

export const OwnerReview = lazy(() => import('./Routes/Applications/Lease/OwnerReview'));
export const LeaseClosure = lazy(() => import('./Routes/Applications/Lease/LeaseClosure'));
export const LeaseClosureSucess = lazy(() => import('./Routes/Applications/Lease/LeaseClosure/SubmitClosure'));
export const LeaseCancellation = lazy(() => import('./Routes/Applications/Lease/LeaseCancellation'));
export const LeaseCancellationSucess = lazy(() =>
  import('./Routes/Applications/Lease/LeaseCancellation/submitCancellation'),
);

export const TenantRejectCancellation = lazy(() =>
  import('./Routes/Applications/Lease/TenantReview/submitRejectionCancel'),
);
export const TenantApprovalCancellation = lazy(() =>
  import('./Routes/Applications/Lease/TenantReview/submitApprovalCancel'),
);
export const TenantApprovalClosure = lazy(() =>
  import('./Routes/Applications/Lease/TenantReview/submitApprovalClosure'),
);
export const LeaseTerminationCourt = lazy(() => import('./Routes/Applications/Lease/TerminationCourtOrder'));
export const LeaseTerminationCourtSucess = lazy(() =>
  import('./Routes/Applications/Lease/TerminationCourtOrder/SubmitTermination'),
);

export const LeasePayment = lazy(() => import('./Routes/Applications/Lease/Payment'));
export const LeasePaymentSuccess = lazy(() => import('./Routes/Applications/Lease/Payment/paymentSuccess'));
export const LeasePaymentSuccessTenant = lazy(() => import('./Routes/Applications/Lease/Payment/paymentSuccessTenant'));
export const LeaseFinalSuccess = lazy(() => import('./Routes/Applications/Lease/FinalSuccess'));

// Sell Purchase
export const BuyerSellerReview = lazy(() => import('./Routes/Applications/SellPurchase/BuyerSellerReview'));
export const OtherSellerApproval = lazy(() =>
  import('./Routes/Applications/SellPurchase/BuyerSellerReview/submitApproval'),
);
export const OtherSellerRejection = lazy(() =>
  import('./Routes/Applications/SellPurchase/BuyerSellerReview/submitRejection'),
);
export const SellPurchaseOwner = lazy(() => import('./Routes/Applications/SellPurchase/OwnerReview'));
export const SellPurchaseOwnerSuccess = lazy(() =>
  import('./Routes/Applications/SellPurchase/OwnerReview/OwnerSuccess'),
);
export const SellPurchaseDMTBooking = lazy(() =>
  import('./Routes/Applications/SellPurchase/OwnerReview/DMTAppointment'),
);
export const SellPurchasePayment = lazy(() => import('./Routes/Applications/SellPurchase/Payment'));
export const SalePurchasePaymentSuccess = lazy(() =>
  import('./Routes/Applications/SellPurchase/Payment/paymentSuccess'),
);
export const SellerTermination = lazy(() => import('./Routes/Applications/SellPurchase/OwnerReview/submitTermination'));

// Register Company Account Application
export const RegisterCompanyApplicationDetails = lazy(() =>
  import('./Routes/Service/Company/RegisterCompany/application/Flows/ApplicationDetails.js'),
);
export const RegisterCompanyReturnFlows = lazy(() =>
  import('./Routes/Service/Company/RegisterCompany/application/Flows/ApprovalReturnFlow.js'),
);
export const AddCompanyEmployeeApplicationDetails = lazy(() =>
  import('./Routes/Service/Company/AddEmployee/application/Flows/applicationDetails'),
);
export const AddCompanyEmployeeApprovalPage = lazy(() =>
  import('./Routes/Service/Company/AddEmployee/application/Flows/ApprovalsFlow'),
);
export const AddCompanyEmployeeReturnedPage = lazy(() =>
  import('./Routes/Service/Company/AddEmployee/application/Flows/ReturnFlow'),
);

// update company
export const UpdateCompanyDetail = lazy(() =>
  import('./Routes/Service/Company/updateCompany/applications/Flows/applicationDetails'),
);

export const UpdateCompanyReturn = lazy(() =>
  import('./Routes/Service/Company/updateCompany/applications/Flows/ApprovalReturnFlow'),
);

// Broker application
export const BrokerReview = lazy(() => import('./Routes/Applications/Broker/BrokerReview'));
export const BrokerOwnerAccept = lazy(() => import('./Routes/Applications/Broker/OwnerAccept'));
export const BrokerOwnerReject = lazy(() => import('./Routes/Applications/Broker/OwnerReject'));
// Owner receives broker’s acceptance of cancellation
export const BrokerAcceptBroker = lazy(() => import('./Routes/Applications/Broker/BrokerAccept'));
// Owner receives broker’s decline of cancellation
export const BrokerRejectBroker = lazy(() => import('./Routes/Applications/Broker/BrokerReject'));
// Broker receives cancellation notification
export const BrokerCancelBroker = lazy(() => import('./Routes/Applications/Broker/BrokerCancellation'));
export const BrokerPayment = lazy(() => import('./Routes/Applications/Broker/Payment'));
// PMA application
export const PmaOwnerReview = lazy(() => import('./Routes/Applications/PMA/OwnerReview'));
export const PmaOwnerReviewSuccess = lazy(() => import('./Routes/Applications/PMA/OwnerReview/sumbitApproval'));
export const PmaOwnerReviewTermination = lazy(() => import('./Routes/Applications/PMA/OwnerReview/submitTermination'));

export const PmaCompanyReview = lazy(() => import('./Routes/Applications/PMA/PmaReview'));
// new added flow for pma
export const PmaPostApprovals = lazy(() =>
  import('./Routes/Service/Lease/PMA/Applications/Flows/ApplicationDetailFlow'),
);
export const PmaPayments = lazy(() => import('./Routes/Service/Lease/PMA/Applications/Flows/PaymentFlow'));
export const OffplanBuySellPayments = lazy(() =>
  import('./Routes/Service/Transction/OffplanBuySell/application/Flows/PaymentFlow'),
);

export const PmaReviewApproval = lazy(() => import('./Routes/Applications/PMA/PmaReview/submitApproval'));
export const PmaReviewReturned = lazy(() => import('./Routes/Applications/PMA/PmaReview/submitRetruned'));
export const PmaReviewRejection = lazy(() => import('./Routes/Applications/PMA/PmaReview/submitRejection'));
export const PmaContractDownload = lazy(() => import('./Routes/Service/Lease/PMA/Success'));
export const PmaPayment = lazy(() => import('./Routes/Applications/PMA/Payment'));

export const MarketData = lazy(() => import('./Routes/MarketData'));
// export const PMASelectProperties = Loadable()//   lazy( () => import('./Routes/Service/PMA/PMAForm/SelectProperties'),
// });
// Application Representative of Off-Plan
export const BuyerReviews = lazy(() =>
  import('./Routes/Applications/RepresentativeOffPlan/BuyerReviewsAndSignsContract/BuyerReview'),
);
/* eslint-disable import/no-cycle */
export const AppointmentBooking = lazy(() => import('./Routes/Applications/RepresentativeOffPlan/AppointmentBooking'));

export const Services = lazy(() => import('./Routes/Service'));

export const Properties = lazy(() => import('./Routes/Properties'));

export const PropertyDetail = lazy(() => import('./Routes/Properties/PropertyDetail/index'));

// Directory
export const Directory = lazy(() => import('./Routes/Directory'));
export const DirectoryProject = lazy(() => import('./Routes/Directory/Projects/DetailsPage'));
export const DirectoryProfession = lazy(() => import('./Routes/Directory/Professions/DetailsPage'));
export const DirectoryProfessionEmployee = lazy(() =>
  import('./Routes/Directory/Professions/DetailsPage/EmployeeDetail'),
);

export const UserProfile = lazy(() => import('./Routes/UserProfile'));

export const Documents = lazy(() => import('./Routes/Documents'));

export const Notification = lazy(() => import('./Routes/Notification'));

export const Signup = lazy(() => import('./Routes/Auth/Signin'));

export const Login = lazy(() => import('./Routes/Auth/Login/index'));

export const OTP = lazy(() => import('./Routes/Auth/OTP'));

export const VerifyEmail = lazy(() => import('./Routes/Auth/nonResident/verifyEmail'));
export const ForgotPassoword = lazy(() => import('./Routes/Auth/nonResident/forgotPassword'));

export const RedirectUAEPass = lazy(() => import('./Routes/Auth/RedirectUAEPass'));
export const AdminPayment = lazy(() => import('./Routes/Admin/Payment'));

export const Signin = lazy(() => import('./Routes/Auth/Signin/index'));
export const Login2 = lazy(() => import('./Routes/Auth/Signin/uae'));

// Guest User lease service
export const MarketDataMobile = lazy(() => import('./Routes/LandingScreen/Pages/MarketDataMobile'));
export const AboutUs = lazy(() => import('./Routes/LandingScreen/Pages/AboutADGMPage'));
export const Authorization = lazy(() => import('./Routes/LandingScreen/Pages/Authorization'));
export const SaleService = lazy(() => import('./Routes/LandingScreen/Pages/SaleService'));
export const LeaseService = lazy(() => import('./Routes/LandingScreen/Pages/LeaseService'));
export const CertificateService = lazy(() => import('./Routes/LandingScreen/Pages/CertificateService'));
export const CompanyService = lazy(() => import('./Routes/LandingScreen/Pages/CompanyManagement'));
export const DirectoryService = lazy(() => import('./Routes/LandingScreen/Pages/Directory'));

export const TermsCondition = lazy(() => import('./Routes/LandingScreen/Pages/TermsAndCondition'));
export const PrivacyPolicy = lazy(() => import('./Routes/LandingScreen/Pages/PrivacyPolicy'));
export const ContactUs = lazy(() => import('./Routes/LandingScreen/Pages/ContactUs'));

export const ADGMOffices = lazy(() => import('./Routes/LandingScreen/Pages/ADGMOffices'));
export const ADGMAtyourPlace = lazy(() => import('./Routes/LandingScreen/Pages/ADGMAtyourPlace'));

export const ADGMelifeService = lazy(() => import('./Routes/LandingScreen/Pages/elifieService'));
export const ADGMelifeServiceSuccess = lazy(() => import('./Routes/LandingScreen/Pages/elifieService/Success'));
// Other
export const NotFound = lazy(() => import('./NotFound/NotFound'));

export const Error = lazy(() => import('./Pages/Error'));
export const VerifyTenantContract = lazy(() => import('./Routes/LandingScreen/Pages/VerifyContract'));
export const PropertyListing = lazy(() => import('./Routes/Applications/PMA/ContractDetail/PropertyListingReview'));
export const PMAContractPropertyListing = lazy(() => import('./Routes/Contracts/Detail/PMA/PropertyListingReview'));
export const PMAContractTermination = lazy(() => import('./Routes/Applications/PMA/Termination'));
export const PMAContractTerminationSubmission = lazy(() =>
  import('./Routes/Applications/PMA/Termination/submitTermination'),
);
export const MusatahaTenantReview = lazy(() => import('./Routes/Applications/Musataha/TenantReview'));
export const MusatahaOwnerReview = lazy(() => import('./Routes/Applications/Musataha/OwnerReview'));
export const MusatahaWaiverOwnerReview = lazy(() => import('./Routes/Applications/WaiverMusataha/SellerReview'));
export const MusatahaWaiverBuyerReview = lazy(() => import('./Routes/Applications/WaiverMusataha/BuyerReview'));
export const WaiverBuyerReturnSuccess = lazy(() =>
  import('./Routes/Applications/WaiverMusataha/BuyerReview/submitReturn'),
);
export const WaiverBuyerRejectionSuccess = lazy(() =>
  import('./Routes/Applications/WaiverMusataha/BuyerReview/submitRejection'),
);
export const WaiverBuyerApprovalSuccess = lazy(() =>
  import('./Routes/Applications/WaiverMusataha/BuyerReview/submitApproval'),
);
export const WaiverOwnerTerminationSuccess = lazy(() =>
  import('./Routes/Applications/WaiverMusataha/SellerReview/submitTermination'),
);
export const WaiverPayment = lazy(() => import('./Routes/Applications/WaiverMusataha/Payment/index'));
export const WaiverPaymentSuccess = lazy(() => import('./Routes/Applications/WaiverMusataha/Payment/paymentSuccess'));
export const WaiverApplicationDetail = lazy(() => import('./Routes/Applications/ApplicationDetail/WaiverMusataha'));

export const MusatahaPayment = lazy(() => import('./Routes/Applications/Musataha/Payment/index'));
export const MusatahaPaymentSuccess = lazy(() => import('./Routes/Applications/Musataha/Payment/paymentSuccess'));
export const MusatahaApplicationDetail = lazy(() => import('./Routes/Applications/ApplicationDetail/Musataha'));
export const WaiverMusatahaDownload = lazy(() => import('./Routes/Applications/WaiverMusataha/FinalSuccess'));
export const MusatahaDownload = lazy(() => import('./Routes/Applications/Musataha/FinalSuccess'));

//  Mortgage
export const MortgageApplicationDetail = lazy(() =>
  import('./Routes/Service/Transction/Mortgage/applications/Flows/applicationDetail'),
);

export const MortgagePostApprovals = lazy(() =>
  import('./Routes/Service/Transction/Mortgage/applications/Flows/ApprovalsFlow'),
);
export const MortgagePostReturn = lazy(() =>
  import('./Routes/Service/Transction/Mortgage/applications/Flows/ApprovalReturnFlow'),
);

export const MortgagePayment = lazy(() =>
  import('./Routes/Service/Transction/Mortgage/applications/Flows/PaymentFlow'),
);

//  Transfer offplan review
export const TransferOffplanApplicationDetail = lazy(() =>
  import('./Routes/Service/Transction/TransferOffplanMortgage/applications/Flows/applicationDetail'),
);
export const TransferOffplanPostApprovals = lazy(() =>
  import('./Routes/Service/Transction/TransferOffplanMortgage/applications/Flows/postApprovalsFlow'),
);
export const TransferOffplanPostReturn = lazy(() =>
  import('./Routes/Service/Transction/TransferOffplanMortgage/applications/Flows/ApprovalReturnFlow'),
);
export const TransferOffplanPayment = lazy(() =>
  import('./Routes/Service/Transction/TransferOffplanMortgage/applications/Flows/PaymentFlow'),
);

// NHL Mortgage
export const NhlMortgageApplicationDetail = lazy(() =>
  import('./Routes/Service/Transction/NhlMortgage/applications/Flows/applicationDetail'),
);

export const NhlMortgagePostApprovals = lazy(() =>
  import('./Routes/Service/Transction/NhlMortgage/applications/Flows/ApprovalsFlow'),
);
export const NhlMortgagePostReturn = lazy(() =>
  import('./Routes/Service/Transction/NhlMortgage/applications/Flows/ApprovalReturnFlow'),
);

export const NhlMortgagePayment = lazy(() =>
  import('./Routes/Service/Transction/NhlMortgage/applications/Flows/PaymentFlow'),
);

// Rent Payment

export const RentPaymentApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/RentPayment/applications/Flows/applicationDetail'),
);
export const RentPaymentPaymentFlow = lazy(() =>
  import('./Routes/Service/Transction/RentPayment/applications/Flows/PaymentFlow'),
);
export const RentPaymentApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/RentPayment/applications/Flows/ApprovalFlow'),
);

export const RentPaymentReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/RentPayment/applications/Flows/ApprovalReturnFlow'),
);

// off plan termination
export const OffPlanTerminationApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/OffPlanTermination/applications/Flows/applicationDetail'),
);
export const OffPlanTerminationApprovals = lazy(() =>
  import('./Routes/Service/Transction/OffPlanTermination/applications/Flows/ApprovalsFlow'),
);
export const OffPlanTerminationReturn = lazy(() =>
  import('./Routes/Service/Transction/OffPlanTermination/applications/Flows/ApprovalReturnFlow'),
);
export const OffPlanTerminationBankFlow = lazy(() =>
  import('./Routes/Service/Transction/OffPlanTermination/applications/Flows/BankCheckerFlow'),
);
export const OffPlanTerminationPaymentFlow = lazy(() =>
  import('./Routes/Service/Transction/OffPlanTermination/applications/Flows/PaymentFlow'),
);

// off plan project registration

export const OffPlanProjectRegistrationApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/OffPlanProjectRegistration/applications/Flows/applicationDetail'),
);
export const OffPlanProjectRegistrationApprovals = lazy(() =>
  import('./Routes/Service/Transction/OffPlanProjectRegistration/applications/Flows/ApprovalsFlow'),
);
export const OffPlanProjectRegistrationReturn = lazy(() =>
  import('./Routes/Service/Transction/OffPlanProjectRegistration/applications/Flows/ApprovalReturnFlow'),
);

export const OffPlanProjectRegistrationPayment = lazy(() =>
  import('./Routes/Service/Transction/OffPlanProjectRegistration/applications/Flows/PaymentFlow'),
);

// Project List
export const ProjectList = lazy(() => import('./Routes/Developers'));

// Developers Projects Listing and Detail
export const DeveloperProjectDetail = lazy(() => import('./Routes/Developers/DetailPage'));
export const DeveloperProjectList = lazy(() => import('./Routes/Developers'));

// Register a Dispute ( DRC )
export const registerDisputeApplicationDetails = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RegisterDispute/applications/Flows/applicationDetail'),
);
export const registerDisputeApprovalsPage = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RegisterDispute/applications/Flows/ApprovalsFlow'),
);
export const registerDisputeReturnedPage = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RegisterDispute/applications/Flows/ReturnFlow'),
);

// Request For Expert Opinion (DRC)
export const RequestForExpertOpinionApprovalsPage = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RequestForExpertOpinion/applications/Flows/ApprovalsFlow'),
);

export const RequestForExpertOpinionApplicationDetails = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RequestForExpertOpinion/applications/Flows/applicationDetail'),
);

export const RequestForExpertOpinionPayment = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RequestForExpertOpinion/applications/Flows/PaymentFlow'),
);
// DRC / Execution Stamp

export const ExecutionStampPaymentFlow = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RequestExecutionStamp/applications/Flows/PaymentFlow'),
);
export const ExecutionStampApplicationDetails = lazy(() =>
  import('./Routes/Service/DisputeResolutionCenter/RequestExecutionStamp/applications/Flows/applicationDetail'),
);

// Profession Registration
export const ProfessionRegistrationApplicationDetails = lazy(() =>
  import('./Routes/Service/ProfessionRegistration/applications/Flows/applicationDetail'),
);

export const ProfessionRegistrationPaymentFlow = lazy(() =>
  import('./Routes/Service/ProfessionRegistration/applications/Flows/paymentFlow'),
);

export const ProfessionRegistrationReturnFlow = lazy(() =>
  import('./Routes/Service/ProfessionRegistration/applications/Flows/returnFlow'),
);
// Escrow Account Applications

export const EscrowAccountApplicationDetailFinal = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowAccountRegistration/applications/Flows/applicationDetailFinalApproval'),
);
export const EscrowAccountApplicationDetail = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowAccountRegistration/applications/Flows/ApplicationDetailFlow'),
);
export const EscrowAccountApplicationPayment = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowAccountRegistration/applications/Flows/PaymentFlow'),
);

export const EscrowAccountApplicationDetailFinalApproval = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowAccountRegistration/applications/Flows/applicationDetailFinalApproval'),
);

// Escrow Service Provider Payment Approval

export const ServiceProviderApprovalApplicationDetailFinal = lazy(() =>
  import(
    './Routes/Service/EscrowAccounts/EscrowServiceProviderPayment/applications/Flows/applicationDetailFinalApproval'
  ),
);

export const ServiceProviderApprovalApplicationDetail = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowServiceProviderPayment/applications/Flows/ApplicationDetailFlow'),
);

export const ServiceProviderApprovalReturnApplicationDetail = lazy(() =>
  import('./Routes/Service/EscrowAccounts/EscrowServiceProviderPayment/applications/Flows/ReturnFlow'),
);

// Offplan Buy Sell

export const OffPlanBuySellApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/OffplanBuySell/application/Flows/ApplicationDetails.js'),
);
export const OffPlanBuySellApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/OffplanBuySell/application/Flows/ApprovalsFlow.js'),
);
export const OffPlanBuySellReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/OffplanBuySell/application/Flows/ApprovalReturnFlow.js'),
);
// Mortgage Release
export const MortgageReleaseApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/MortgageRelease/application/Flows/applicationDetails'),
);

export const MortgageReleaseApplicationPayment = lazy(() =>
  import('./Routes/Service/Transction/MortgageRelease/application/Flows/PaymentFlow'),
);

export const MortgageReleaseApplicationApproval = lazy(() =>
  import('./Routes/Service/Transction/MortgageRelease/application/Flows/ApprovalsFlow'),
);

export const MortgageReleaseApplicationReturn = lazy(() =>
  import('./Routes/Service/Transction/MortgageRelease/application/Flows/ReturnFlow'),
);

// Permits

export const PermitsApplicationDetails = lazy(() =>
  import('./Routes/Service/Permits/applications/Flows/applicationDetail'),
);

// valuation certificate
export const ValuationCertificateApplicationDetails = lazy(() =>
  import('./Routes/Service/Certificates/Valuation/applications/Flows/ApplicationDetailFlow'),
);
export const ValuationCertificateReturnFlow = lazy(() =>
  import('./Routes/Service/Certificates/Valuation/applications/Flows/ReturnFlow'),
);

// Musataha Contract Registration
export const MusatahaContractRegistrationApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/MusatahaContractRegistration/applications/Flows/approvalFlow'),
);

export const MusatahaContractRegistrationAppDetail = lazy(() =>
  import('./Routes/Service/Transction/MusatahaContractRegistration/applications/Flows/applicationDetail'),
);
export const MusatahaContractPayemnt = lazy(() =>
  import('./Routes/Service/Transction/MusatahaContractRegistration/applications/Flows/paymentFlow'),
);

export const MusatahaContractRegReturn = lazy(() =>
  import('./Routes/Service/Transction/MusatahaContractRegistration/applications/Flows/returnFlow'),
);

// Sell & Purchase
export const SellAndPurchaseApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/SellPurchase/applications/Flows/applicationDetails'),
);
export const SellAndPurchaseApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/SellPurchase/applications/Flows/ApprovalFlow'),
);
export const SellAndPurchaseReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/SellPurchase/applications/Flows/ReturnFlow'),
);
export const SellAndPurchasePaymentFLow = lazy(() =>
  import('./Routes/Service/Transction/SellPurchase/applications/Flows/PaymentFlow'),
);

// Transfer of Interest
export const TransferOfInterestApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/TransferOfInterest/applications/Flows/applicationDetails'),
);
export const TransferOfInterestApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/TransferOfInterest/applications/Flows/ApprovalFlow'),
);
export const TransferOfInterestReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/TransferOfInterest/applications/Flows/ReturnFlow'),
);
export const TransferOfInterestPaymentFLow = lazy(() =>
  import('./Routes/Service/Transction/TransferOfInterest/applications/Flows/PaymentFlow'),
);

// Digital Transfer of Interest
export const DigitalTransferOfInterestApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/DigitalTransferOfInterest/applications/Flows/applicationDetails'),
);
export const DigitalTransferOfInterestApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/DigitalTransferOfInterest/applications/Flows/ApprovalFlow'),
);
export const DigitalTransferOfInterestReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/DigitalTransferOfInterest/applications/Flows/ReturnFlow'),
);
export const DigitalTransferOfInterestPaymentFLow = lazy(() =>
  import('./Routes/Service/Transction/DigitalTransferOfInterest/applications/Flows/PaymentFlow'),
);

// Power Of Attorney
export const RegisterPOAApplicationDetails = lazy(() =>
  import('./Routes/Service/Authorization/PowerOfAttorney/RegisterPOA/application/Flows/applicationDetail'),
);

export const RegisterPOAApplicationReturn = lazy(() =>
  import('./Routes/Service/Authorization/PowerOfAttorney/RegisterPOA/application/Flows/ReturnFlow'),
);

export const TerminatePOAApplicationDetails = lazy(() =>
  import('./Routes/Service/Authorization/PowerOfAttorney/TerminatePOA/ApplicationDetails'),
);

// Manual Profile Creation
export const ManualProfileCreationApplicationDetails = lazy(() =>
  import('./Routes/Service/Profile/ManualProfileCreation/application/Flows/ApplicationDetails.js'),
);
export const ManualProfileCreationReturnFlow = lazy(() =>
  import('./Routes/Service/Profile/ManualProfileCreation/application/Flows/ApprovalReturnFlow.js'),
);

// Instant Services
export const InstantServiceApplicationDetails = lazy(() =>
  import('./Routes/Service/InstantServices/application/Flows/ApplicationDetails'),
);

export const InstantServicePaymentFlow = lazy(() =>
  import('./Routes/Service/InstantServices/application/Flows/PaymentFlow'),
);

// Certificates V2
export const CertificatesApplicationDetails = lazy(() =>
  import('./Routes/Service/Certificates/application/Flows/ApplicationDetails'),
);

export const CertificatesPaymentFlow = lazy(() =>
  import('./Routes/Service/Certificates/application/Flows/PaymentFlow'),
);

// Mortgage Modification
export const MortgageModificationApplicationDetail = lazy(() =>
  import('./Routes/Service/Transction/MortgageModification/application/ApplicationDetails'),
);

export const MortgageModificationReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/MortgageModification/application/ReturnFlow'),
);

export const MortgageModificationApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/MortgageModification/application/ApprovalFlow'),
);

export const MortgageModificationPaymentFlow = lazy(() =>
  import('./Routes/Service/Transction/MortgageModification/application/PaymentFlow'),
);

// Legal Notice
export const LegalNoticeReturnFlow = lazy(() =>
  import('./Routes/Service/Transction/LegalNotice/application/Flows/ApprovalReturnFlow'),
);

export const LegalNoticeApprovalFlow = lazy(() =>
  import('./Routes/Service/Transction/LegalNotice/application/Flows/ApprovalsFlow'),
);

export const LegalNoticeApplicationDetails = lazy(() =>
  import('./Routes/Service/Transction/LegalNotice/application/Flows/ApplicationDetails'),
);
